import { AnyAction, combineReducers } from '@reduxjs/toolkit';

import preQualificationData from './preQualificationData';
import preQualificationResult from './preQualificationResult';
import yourName from './yourName';
import yourAddress from './yourAddress';
import creditReport from './creditReport';
import applicationStep from './applicationStep';
import preQualificationDecline from './preQualificationDecline';
import loanOffer from './loanOffer';
import docuSignEnvelope from './docuSignEnvelope';
import argyle from './argyle';
import applicationData from './applicationData';
import bankAccount from './bankAccount';
import filesUpload from './filesUpload';
import employmentData from './employmentData';
import userPayrollData from './userPayrollData';
import loanTermsData from './loanTerms';
import employers from './employers';
import payrollProviders from './payrollProviders';
import userPayrollDataGet from './userPayrollDataGet';
import userHistory from './userHistory';
import referrals from './referrals';
import plaidPublicToken from './plaidPublicToken';
import emailService from './emailService';
import yourContact from './yourContact';
import kyc from './kyc';
import yourGoal from './yourGoal';
import paymentAccount from './paymentAccount';
import yourBirthDate from './yourBirthDate';
import yourSSN4 from './yourSSN4';
import yourEmployer from './yourEmployer';
import yourIncome from './yourIncome';
import methodAuth from './methodAuth';
import cardData from './cardData';
import theme from './theme';
import auth from './auth';
import professionGroup from './professionGroup';
import studentLoanData from './studentLoanData';
import studentLoanScheduleData from './studentLoanScheduleData';
import studentLoanApplication from './studentLoanApplicationData';
import paycheckSwitchData from './paycheckSwitchData';
import latestLoanPayment from './latestLoanPayment';
import reports from './reports';
import creditScoreHistory from './creditScoreHistory';
import nursegridData from './nursegridData';
import loanBreakdown from './loanBreakdown';
import payoffPayments from './payoffPayments';
import aiChat from './aiChat';
import aiCoachConversation from './aiCoachConversation';
import goalOptimizer from './goalOptimizer';
import shiftWizard from './shiftWizard';
import shiftImpact from './shiftImpact';
import financialMetrics from './financialMetrics';
import upcomingLoanPayments from './upcomingLoanPayments';

export const LOGOUT_ACTION_TYPE = 'LOGOUT';

const appReducer = combineReducers({
  loanTermsData,
  preQualificationData,
  preQualificationResult,
  preQualificationDecline,
  yourName,
  yourAddress,
  yourIncome,
  creditReport,
  applicationStep,
  loanOffer,
  docuSignEnvelope,
  argyle,
  applicationData,
  bankAccount,
  filesUpload,
  employmentData,
  userPayrollData,
  userPayrollDataGet,
  employers,
  payrollProviders,
  userHistory,
  referrals,
  plaidPublicToken,
  emailService,
  yourContact,
  kyc,
  yourGoal,
  paymentAccount,
  yourBirthDate,
  yourSSN4,
  yourEmployer,
  methodAuth,
  cardData,
  theme,
  auth,
  professionGroup,
  studentLoanData,
  studentLoanScheduleData,
  studentLoanApplication,
  paycheckSwitchData,
  latestLoanPayment,
  reports,
  creditScoreHistory,
  nursegridData,
  loanBreakdown,
  payoffPayments,
  aiChat,
  aiCoachConversation,
  goalOptimizer,
  shiftWizard,
  shiftImpact,
  financialMetrics,
  upcomingLoanPayments,
});

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: AnyAction,
): ReturnType<typeof appReducer> => {
  if (action.type === LOGOUT_ACTION_TYPE) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
